import { render } from "./LocaleSwitcherNO_URL.vue?vue&type=template&id=2f1eabc8"
import script from "./LocaleSwitcherNO_URL.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcherNO_URL.vue?vue&type=script&lang=js"
script.render = render

export default script